import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ onClick, children, disabled = false }) => {
  return (
    <motion.button
      className="button"
      onClick={onClick}
      disabled={disabled}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      {children}
    </motion.button>
  );
};

export default Button;